import { Link } from 'react-router-dom';
import {
  UsersRound,
  Pill,
  Ambulance,
  PackagePlus,
  PackageSearch,
  ClipboardCheck,
  HeartPulse
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

type CareMenuItem = {
  to: string;
  label: string;
  description: string;
  icon: LucideIcon;
  accent: string;
};

const careMenuItems: CareMenuItem[] = [
  {
    to: '/admin/residents',
    label: '入居者管理',
    description: '入居者・退居者の基本情報とバイタルを確認します',
    icon: UsersRound,
    accent: 'bg-cyan-700'
  },
  {
    to: '/admin/medicine',
    label: '残薬管理',
    description: '残薬数、往診依頼候補、医療機関別の一覧を確認します',
    icon: Pill,
    accent: 'bg-emerald-700'
  },
  {
    to: '/admin/emergency',
    label: '救急情報',
    description: '救急情報提供書の作成と印刷を行います',
    icon: Ambulance,
    accent: 'bg-rose-700'
  },
  {
    to: '/admin/supplies',
    label: '物品販売',
    description: '日用品の利用チェックと月末請求をまとめます',
    icon: PackagePlus,
    accent: 'bg-teal-700'
  },
  {
    to: '/inventory',
    label: '在庫管理',
    description: '手袋や衛生用品の在庫と発注の目安を確認します',
    icon: PackageSearch,
    accent: 'bg-indigo-700'
  },
  {
    to: '/resident-entry',
    label: '入退居登録',
    description: '新しい入居者の登録と退居の手続きを行います',
    icon: ClipboardCheck,
    accent: 'bg-slate-700'
  }
];

const CareHome = () => (
  <div className="min-h-screen bg-slate-50 text-slate-900">
    <header className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center gap-3 px-4 py-5 sm:px-6">
        <div className="grid h-12 w-12 place-items-center rounded-lg bg-cyan-700 text-white">
          <HeartPulse className="h-6 w-6" />
        </div>
        <div>
          <h1 className="text-xl font-bold">ケア業務</h1>
          <p className="text-sm text-slate-500">さつきホーム 入居者に関する業務メニュー</p>
        </div>
      </div>
    </header>

    <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6">
      <div className="grid gap-4 sm:grid-cols-2">
        {careMenuItems.map(item => {
          const Icon = item.icon;
          return (
            <Link
              key={item.to}
              to={item.to}
              className="flex items-start gap-4 rounded-xl border border-slate-200 bg-white p-5 shadow-sm transition hover:border-cyan-300 hover:shadow-md"
            >
              <div className={`grid h-12 w-12 shrink-0 place-items-center rounded-lg text-white ${item.accent}`}>
                <Icon className="h-6 w-6" />
              </div>
              <div>
                <p className="text-base font-bold text-slate-900">{item.label}</p>
                <p className="mt-1 text-sm text-slate-600">{item.description}</p>
              </div>
            </Link>
          );
        })}
      </div>

      <p className="mt-6 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm text-slate-600">
        勤怠・給与などの労務は、このページからは操作できません。管理者用の画面で管理しています。
      </p>
    </main>
  </div>
);

export default CareHome;
